module.exports = __webpack_public_path__ + "img/portrait-057.fc3b3260.jpg";